module.exports = __webpack_public_path__ + "dfa8f8e9e532b47755e130988f817da5.png";